export default "__VITE_ASSET__COOSeuxe__"